
import {Component, Vue} from "vue-property-decorator";
import SafetyReportConfigurationTable from "@/components/safety/SafetyReportConfigurationTable.vue";
import SafetyScreeningReport from "@/components/safety/SafetyScreeningReport.vue";

@Component({
  components: {SafetyScreeningReport, SafetyReportConfigurationTable}
})
export default class SafetyScreeningReportView extends Vue {

  async handleActivateScreeningReport() {
    await (this.$refs["safetyScreeningReport"] as SafetyScreeningReport).loadSafetyScreeningReport();
  }

}
